import { createContext, useContext, useEffect, useState } from "react";
import {
  type TabLeadershipState,
  tabLeadershipManager,
} from "./tab-leadership-manager";

export type { TabLeadershipState } from "./tab-leadership-manager";

export const TabLeadershipContext = createContext<TabLeadershipState | null>(
  null,
);

export const TabLeadershipProvider: FCwC = ({ children }) => {
  const [state, setState] = useState<TabLeadershipState>(() =>
    tabLeadershipManager.getCurrentState(),
  );

  useEffect(() => {
    tabLeadershipManager.initialize();

    return tabLeadershipManager.subscribe(setState);
  }, []);

  return (
    <TabLeadershipContext.Provider value={state}>
      {children}
    </TabLeadershipContext.Provider>
  );
};

export const useTabLeadership = (): TabLeadershipState => {
  const context = useContext(TabLeadershipContext);
  if (!context) {
    throw new Error(
      "useTabLeadership must be used within a TabLeadershipProvider",
    );
  }
  return context;
};
